/* eslint-disable class-methods-use-this */

import LiveChatHandler from '../handlers/LiveChatHandler';
import {
	BaseMessageSender,
	BaseMessageSenderParams,
	SendMessageResponse,
} from './BaseMessageSender';

export class LiveChatMessageSender implements BaseMessageSender {
	sendMessage(params: BaseMessageSenderParams): Promise<SendMessageResponse> {
		return LiveChatHandler.sendMessage(params);
	}
}

export default LiveChatMessageSender;
